module.exports = __webpack_public_path__ + "img/MilkyWayCore50mmStitch_thumb.6581c76c.jpg";